const container = "min-h-screen bg-background flex items-center justify-center p-4";

const card = "w-full max-w-lg rounded-xl border border-border bg-card shadow-card";

const cardHeader = "flex flex-col items-center gap-1.5 p-4 sm:p-6 pb-4 text-center";

const cardHeaderRow = "flex items-center justify-between w-full gap-4";

const cardHeaderTitleGroup = "flex flex-col items-start gap-1.5";

const cardTitle = "text-2xl font-semibold text-foreground";

const progressContainer = "flex items-center justify-center gap-12 px-8 pb-6 pt-4";

const content = "px-4 sm:px-6 pb-4 sm:pb-6";

const section = "space-y-4";

const input =
  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-primary focus-visible:ring-primary";

const select =
  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:border-primary focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50";

const checkboxLabel = "flex items-center gap-2 text-sm text-foreground";

const actions = "flex items-center justify-between pt-4";

const backBtn = "rounded-md text-sm font-medium text-muted-foreground hover:text-foreground transition-colors px-3 py-1.5";

const primaryBtn =
  "rounded-md bg-primary text-primary-foreground shadow hover:bg-primary/90 text-sm font-medium px-4 py-1.5 transition-colors disabled:opacity-50 disabled:pointer-events-none";

const skipBtn = "text-xs text-muted-foreground hover:text-foreground underline transition-colors";

const successContainer = "flex flex-col items-center gap-4 py-8 text-center";

const successIcon = "h-16 w-16 rounded-full bg-success/10 flex items-center justify-center";

const successTitle = "text-xl font-semibold text-foreground";

const error = "mb-4 rounded-md bg-destructive/10 px-4 py-2 text-sm text-destructive";

const successIconInner = "h-8 w-8 text-success";

const titleRow = "flex items-center gap-2 mb-1";

const titleIcon = "h-5 w-5 text-primary";

const backBtnIcon = "h-4 w-4 mr-1";

const skipBtnIcon = "h-3.5 w-3.5 mr-1";

const finishIcon = "h-4 w-4 ml-1.5";

export {
  container,
  card,
  cardHeader,
  cardHeaderRow,
  cardHeaderTitleGroup,
  cardTitle,
  progressContainer,
  content,
  section,
  input,
  select,
  checkboxLabel,
  actions,
  backBtn,
  primaryBtn,
  skipBtn,
  successContainer,
  successIcon,
  successTitle,
  error,
  successIconInner,
  titleRow,
  titleIcon,
  backBtnIcon,
  skipBtnIcon,
  finishIcon,
};
